import { EFileType } from '_/types/common.types';
import { ECompressionType } from '_/types/destinations/destinations.types';

import { IDestinationForm } from './DestinationForms.types';

export const INITIAL_DESTINATION: IDestinationForm = {
  active: true,
  compressionType: ECompressionType.GZIP,
  configuration: {},
  encryptedConfig: {},
  fileType: EFileType.INDIVIDUAL,
  files: {},
  name: '',
  type: '',
};

export const ZIP_FILE_TYPES = ['jsonZip', 'pagesJsonZip', 'statsJsonZip', 'customZip'];
